// Facebook brand colour so not from our brand colour palette

// eslint-disable-next-line @thebeansgroup/sb/no-hex-literals
export const FACEBOOK_COLOUR = '#486BB6'
